import { combineReducers } from 'redux'
import auth from './auth'
import locale from './locale/localeSlice'
import listData from './data/dataSlice'
import filterData from './filterdata/filterDataSlice'
import table from './table/tableSlice'

const rootReducer = asyncReducers => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        locale,
        table,
        listData,
        filterData,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
